// 回答期間（＝対象者がマイ・サーベイで回答できる期間）の判定 — 回答差戻しの可否に使う（2026-11）
// ------------------------------------------------------------------
// 差戻しても対象者が回答できない（期間外）と困るため、回答期間内のチケットだけ差戻しできるようにする。
// マイ・サーベイ（MySurveyPage の isInSurveyPeriod・トライアルの token_expire 判定）と同じ結果にする。
// サーバー rcdr_server/utils/answerPeriod.js と同じ規則（サーバーでも差戻しを拒否する）。変更するときは両方そろえる。
//
// - シーズンあり: 今日（JST）が survey_start_date〜survey_end_date の日付（ISO の日付部分）の範囲内（両端含む）
// - シーズンなし（トライアル等）: 今日（JST）≤ token_expire（JST の日付）。token_expire も無ければ期間外
// - シーズンが見つからない: 期間外
const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

const toDate = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

// ISO 文字列の日付部分（マイ・サーベイの startDateStr.split('T')[0] と同じ）
export const isoDateKey = (v) => {
  const d = toDate(v);
  return d ? d.toISOString().slice(0, 10) : null;
};

// その瞬間が属する JST の日付 'YYYY-MM-DD'
export const jstDateKey = (v) => {
  const d = toDate(v);
  return d ? new Date(d.getTime() + JST_OFFSET_MS).toISOString().slice(0, 10) : null;
};

const slash = (key) => (key ? key.replace(/-/g, '/') : '');

/**
 * チケットの回答期間を判定する。
 * @param {{ survey_season_id?: string, token_expire?: string }} token
 * @param {{ survey_start_date?: string, survey_end_date?: string }|null|undefined} season
 * @param {Date} [now]
 * @returns {{ open: boolean, label: string }} label = 表示用の期間（例: '2026/04/01〜2026/04/30'）
 */
export const resolveAnswerPeriod = (token, season, now = new Date()) => {
  const today = jstDateKey(now);
  if (token && token.survey_season_id) {
    const start = season ? isoDateKey(season.survey_start_date) : null;
    const end = season ? isoDateKey(season.survey_end_date) : null;
    if (!start || !end) return { open: false, label: '' };
    return { open: today >= start && today <= end, label: `${slash(start)}〜${slash(end)}` };
  }
  const expire = jstDateKey(token && token.token_expire);
  if (!expire) return { open: false, label: '' };
  return { open: today <= expire, label: `〜${slash(expire)}` };
};
